var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconQuanLy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 45 45",
    style: {
      enableBackground: "new 0 0 45 45"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000132079142736689625390000009773912000208374934_);}\n\t.st2{fill:url(#SVGID_00000127007430888190916350000008560474541210458500_);}\n\t.st3{fill:url(#SVGID_00000156548794397872708590000007012615953582829499_);}\n\t.st4{fill:url(#SVGID_00000117649837472705086930000012471920189452475581_);}\n\t.st5{fill:url(#SVGID_00000058559706665407453070000001784339811592491454_);}\n\t.st6{fill:url(#SVGID_00000171689632034112451960000017688248738653324676_);}\n\t.st7{fill:url(#SVGID_00000105388851107838184900000003794947863551936183_);}\n\t.st8{fill:url(#SVGID_00000159454232567539263120000017492394960672637080_);}\n\t.st9{fill:url(#SVGID_00000152264264930352608330000000031570852533703863_);}\n\t.st10{fill:url(#SVGID_00000176011380411558720680000014511130125799943606_);}\n\t.st11{fill:url(#SVGID_00000053529422668751887380000000130894178207554750_);}\n\t.st12{fill:url(#SVGID_00000118376247212570610220000011984055953034567597_);}\n\t.st13{fill:url(#SVGID_00000018916200209610259690000011163835099410063501_);}\n\t.st14{fill:url(#SVGID_00000146461151992118778730000017725853310464447661_);}\n\t.st15{fill:url(#SVGID_00000115481808256029196270000014573902408911789482_);}\n\t.st16{fill:url(#SVGID_00000133512755460790312320000006698030169735112106_);}\n\t.st17{fill:url(#SVGID_00000152228518728808036900000002131373491330559880_);}\n\t.st18{fill:url(#SVGID_00000088817088719619183570000005730624586976123536_);}\n\t.st19{fill:url(#SVGID_00000133496989118973130950000001508838376958678704_);}\n\t.st20{fill:url(#SVGID_00000008129504883320068720000014661311845185718717_);}\n\t.st21{fill:url(#SVGID_00000101811392057978980760000002833771890069253257_);}\n\t.st22{fill:url(#SVGID_00000097498761977332450040000008848497235068052099_);}\n\t.st23{fill:url(#SVGID_00000065756094495376716560000005312904174328724145_);}\n\t.st24{fill:url(#SVGID_00000075158795375176893110000008856413292266484891_);}\n\t.st25{fill:url(#SVGID_00000137831189185055436220000016671866714109956235_);}\n\t.st26{fill:url(#SVGID_00000042698097362758807210000001824453545077717159_);}\n\t.st27{fill:url(#SVGID_00000134954227190563146820000006379983530270891924_);}\n\t.st28{fill:url(#SVGID_00000018206769770998073260000012529008354767863196_);}\n\t.st29{fill:url(#SVGID_00000140723401719444634580000018441083199293739917_);}\n\t.st30{fill:url(#SVGID_00000136396101782047983500000007296885616426834363_);}\n\t.st31{fill:url(#SVGID_00000083048169654461491940000006272718588984490680_);}\n\t.st32{fill:url(#SVGID_00000138543761977719395640000013217432499680783242_);}\n\t.st33{fill:url(#SVGID_00000109007541834089084300000016642956364343285665_);}\n\t.st34{fill:url(#SVGID_00000114760509596897085230000017660329250304922034_);}\n\t.st35{fill:url(#SVGID_00000117655070646157591450000000410878170330683798_);}\n\t.st36{fill:url(#SVGID_00000005255942442023173890000013965379924544510121_);}\n\t.st37{fill:url(#SVGID_00000065777416038453009400000008427360391734930091_);}\n\t.st38{fill:url(#SVGID_00000095323507992999859880000004272579458425442998_);}\n\t.st39{fill:url(#SVGID_00000017483063788576042130000007999708038198918791_);}\n\t.st40{fill:url(#SVGID_00000177483050262028314270000011497932249080794301_);}\n\t.st41{fill:url(#SVGID_00000042728069721615835740000012583256513519546752_);}\n\t.st42{fill:url(#SVGID_00000050621184033961731980000001136708522758370968_);}\n\t.st43{fill:url(#SVGID_00000090255350421244807400000012862735753042790294_);}\n\t.st44{fill:url(#SVGID_00000037657851097754313060000002077811554777167798_);}\n\t.st45{fill:url(#SVGID_00000039125880878586400100000016501235414561806776_);}\n\t.st46{fill:url(#SVGID_00000155851538102955748970000010493907759442035873_);}\n\t.st47{fill:url(#SVGID_00000008827690285594589220000003190965075927208104_);}\n\t.st48{fill:url(#SVGID_00000018203713216203439460000004266710518930147768_);}\n\t.st49{fill:url(#SVGID_00000111191823540902572050000006004130488885559221_);}\n\t.st50{fill:url(#SVGID_00000029009688094977975280000001294544566346540477_);}\n\t.st51{fill:url(#SVGID_00000011025416814190925220000007039967925816125361_);}\n\t.st52{fill:url(#SVGID_00000105410694859482902440000007434964897959885952_);}\n\t.st53{fill:url(#SVGID_00000000214942981041428920000010927838955088825475_);}\n\t.st54{fill:url(#SVGID_00000114771679831796876600000018065062820693936033_);}\n\t.st55{fill:url(#SVGID_00000165213059428255825000000004555137012912249765_);}\n\t.st56{fill:url(#SVGID_00000130649041201456805160000011682109143425935514_);}\n\t.st57{fill:#FFFFFF;}\n\t.st58{fill:url(#SVGID_00000158716050411053487470000003374007889159114937_);}\n\t.st59{fill:url(#SVGID_00000020385106017893594720000003143868154992829312_);}\n\t.st60{fill:url(#SVGID_00000013880832108427511650000006711480526561830064_);}\n\t.st61{fill:url(#SVGID_00000141415522313509325180000010827740105640019608_);}\n\t.st62{fill:url(#SVGID_00000065035129726281032520000014724621807140222910_);}\n\t.st63{fill:url(#SVGID_00000013182833977270466180000012643374398140616883_);}\n\t.st64{fill:url(#SVGID_00000048503076641062655730000011055998017660133288_);}\n\t.st65{fill:url(#SVGID_00000183949757385098879370000015273365104725923977_);}\n\t.st66{fill:url(#SVGID_00000043426605974005086430000006997817210070109575_);}\n\t.st67{fill:url(#SVGID_00000112634968558192270400000007324765204373255305_);}\n\t.st68{fill:url(#SVGID_00000093893988035213587380000002450945826184649394_);}\n\t.st69{fill:url(#SVGID_00000093857736270647201420000018018232886011138720_);}\n\t.st70{fill:url(#SVGID_00000128452184641511217820000005051275388204777880_);}\n\t.st71{fill:url(#SVGID_00000108991758982243271300000003977843943276028839_);}\n\t.st72{fill:url(#SVGID_00000051356584785328451490000003286568700317430183_);}\n\t.st73{fill:url(#SVGID_00000078757270341247207270000014384971075951713426_);}\n\t.st74{fill:url(#SVGID_00000093860769750231561860000013081201650143883164_);}\n\t.st75{fill:url(#SVGID_00000026136066225928311200000000442654279306840962_);}\n\t.st76{fill:url(#SVGID_00000155135521708194842750000018256083868631770761_);}\n\t.st77{fill:url(#SVGID_00000100368161482722153690000015009991676066838952_);}\n\t.st78{fill:url(#SVGID_00000019656936591909473650000015175098846381273273_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.9212,
    y1: 41.4028,
    x2: 29.1765,
    y2: 11.7857
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE4035"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6935A"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.57,36.49c-5.91,0-11.82,0-17.72,0c0-6.25,0-12.5,0-18.76c0-1.12-0.02-2.25,0-3.37 c0.04-2.8,1.91-5.24,4.72-5.76c1.08-0.2,2.27-0.09,3.36-0.09c2.05,0,4.11,0,6.16,0c3.11,0,6.22,0,9.33,0c0,3.93,0,7.86,0,11.79 c0,2.41,3.75,2.42,3.75,0c0-4.56,0-9.11,0-13.67c0-1.01-0.86-1.88-1.88-1.88c-3.32,0-6.65,0-9.97,0c-3.34,0-6.73-0.16-10.07,0.01 c-3.56,0.17-6.84,2.3-8.3,5.58c-0.97,2.18-0.86,4.45-0.86,6.78c0,3.25,0,6.5,0,9.75c0,3.83,0,7.66,0,11.49 c0,1.01,0.86,1.88,1.88,1.88c6.53,0,13.07,0,19.6,0C28.98,40.24,28.98,36.49,26.57,36.49z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000025405135762475155820000004367350378244038062_",
    gradientUnits: "userSpaceOnUse",
    x1: 12.192,
    y1: 52.1553,
    x2: 40.4473,
    y2: 22.5383
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE4035"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6935A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000025405135762475155820000004367350378244038062_)"
    },
    d: "M39.48,32.38 c0.26-0.34,0.43-0.71,0.43-1.17c0-0.46-0.2-1.01-0.55-1.33c-1.94-2.13-3.87-4.26-5.81-6.38c-0.68-0.75-1.96-0.69-2.65,0 c-0.75,0.75-0.68,1.9,0,2.65c0.97,1.06,1.93,2.12,2.9,3.18c-2.27,0-4.54,0-6.81,0c-0.53,0-1.06,0-1.59,0 c-1.01,0-1.88,0.86-1.88,1.88c0,1.02,0.86,1.88,1.88,1.88c2.88,0,5.77,0,8.65,0c-0.85,1.02-1.69,2.04-2.54,3.06 c-0.25,0.3-0.49,0.59-0.74,0.89c-0.33,0.39-0.55,0.8-0.55,1.33c0,0.46,0.2,1.01,0.55,1.33c0.69,0.63,1.98,0.81,2.65,0 c1.73-2.09,3.47-4.17,5.2-6.26c0.25-0.3,0.49-0.59,0.74-0.89c0.04-0.05,0.07-0.1,0.11-0.15C39.47,32.39,39.48,32.39,39.48,32.38z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013181217400308050790000008729927806026775203_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.9266,
    y1: 42.3619,
    x2: 30.1819,
    y2: 12.7449
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE4035"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6935A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000013181217400308050790000008729927806026775203_)"
    },
    d: "M28.25,15.04c-0.98,0-1.97,0-2.95,0 c-0.14,0-0.28,0-0.42,0c-0.38,0-0.79,0.17-1.06,0.44c-0.26,0.26-0.46,0.69-0.44,1.06c0.04,0.81,0.66,1.5,1.5,1.5 c0.98,0,1.97,0,2.95,0c0.14,0,0.28,0,0.42,0c0.38,0,0.79-0.17,1.06-0.44c0.26-0.26,0.46-0.69,0.44-1.06 C29.71,15.72,29.09,15.04,28.25,15.04z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000174587858986010296340000012865946715744480643_",
    gradientUnits: "userSpaceOnUse",
    x1: 5.0508,
    y1: 45.3425,
    x2: 33.3061,
    y2: 15.7254
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE4035"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6935A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000174587858986010296340000012865946715744480643_)"
    },
    d: "M28.25,21.29c-0.98,0-1.97,0-2.95,0 c-0.14,0-0.28,0-0.42,0c-0.38,0-0.79,0.17-1.06,0.44c-0.26,0.26-0.46,0.69-0.44,1.06c0.04,0.81,0.66,1.5,1.5,1.5 c0.98,0,1.97,0,2.95,0c0.14,0,0.28,0,0.42,0c0.38,0,0.79-0.17,1.06-0.44c0.26-0.26,0.46-0.69,0.44-1.06 C29.71,21.98,29.09,21.29,28.25,21.29z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000104676463491341313220000002222317415575986075_",
    gradientUnits: "userSpaceOnUse",
    x1: -3.2418,
    y1: 37.4312,
    x2: 25.0136,
    y2: 7.8142
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE4035"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6935A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000104676463491341313220000002222317415575986075_)"
    },
    d: "M20.21,15.04c-2.05,0-4.11,0-6.16,0 c-0.29,0-0.58,0-0.87,0c-0.78,0-1.54,0.69-1.5,1.5c0.04,0.81,0.66,1.5,1.5,1.5c2.05,0,4.11,0,6.16,0c0.29,0,0.58,0,0.87,0 c0.78,0,1.54-0.69,1.5-1.5C21.67,15.72,21.05,15.04,20.21,15.04z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008860896257865858400000002873978502256568486_",
    gradientUnits: "userSpaceOnUse",
    x1: -0.1176,
    y1: 40.4118,
    x2: 28.1378,
    y2: 10.7947
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE4035"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6935A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008860896257865858400000002873978502256568486_)"
    },
    d: "M20.21,21.29c-2.05,0-4.11,0-6.16,0 c-0.29,0-0.58,0-0.87,0c-0.78,0-1.54,0.69-1.5,1.5c0.04,0.81,0.66,1.5,1.5,1.5c2.05,0,4.11,0,6.16,0c0.29,0,0.58,0,0.87,0 c0.78,0,1.54-0.69,1.5-1.5C21.67,21.98,21.05,21.29,20.21,21.29z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000167355715145418720460000006890450209070348718_",
    gradientUnits: "userSpaceOnUse",
    x1: 3.0067,
    y1: 43.3923,
    x2: 31.262,
    y2: 13.7753
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE4035"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6935A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000167355715145418720460000006890450209070348718_)"
    },
    d: "M20.21,27.55c-2.05,0-4.11,0-6.16,0 c-0.29,0-0.58,0-0.87,0c-0.78,0-1.54,0.69-1.5,1.5c0.04,0.81,0.66,1.5,1.5,1.5c2.05,0,4.11,0,6.16,0c0.29,0,0.58,0,0.87,0 c0.78,0,1.54-0.69,1.5-1.5C21.67,28.23,21.05,27.55,20.21,27.55z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuanLy);
export default __webpack_public_path__ + "static/media/icon_quan_ly.348e310d2607cc6a2a9e17f541455494.svg";
export { ForwardRef as ReactComponent };